import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_035",
  "use": "icon-wo_035-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-wo_035\"><defs><style>#icon-wo_035 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_035_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_035_icon\"><rect class=\"cls-1\" width=\"20\" height=\"20\" /><polygon class=\"cls-2\" points=\"7.71 17.71 6.29 16.29 12.59 10 6.29 3.71 7.71 2.29 15.41 10 7.71 17.71\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol